<template>
  <span>
    <div class="row">
      <div class="col-md-6">
        <label class="col-form-label">Owner Name</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.owner_name"
            class="form-control"
            autocomplete="off"
            placeholder="Owner Name"
          />
        </div>
      </div>
      <div class="col-md-6">
        <label class="col-form-label">Remarks</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.remarks"
            class="form-control"
            placeholder="Remarks"
          />
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
export default {
  name: "OwnerFormWidget",
  props: ["form"],
};
</script>
